export default __webpack_public_path__ + "static/sgcc-apple-consultants-network-75d83397e25910fef89680c7144edbb4.png";